import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { sendGoogleAnalyticsMetrics } from "../../store/actions/googleAnalytics";
import { gaEventsMap } from "./constants";

export const useTrackingHistory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (path, replace = false, state = null) => {
    dispatch(sendGoogleAnalyticsMetrics(gaEventsMap[path]));
    navigate(path, { state, replace });
  };
};
